import type { CreateMusicForm, CreateMusicOrder } from './types';

const DRAFT_KEY = 'inspira_criar_musica_v1_draft';
const ORDER_PREFIX = 'inspira_criar_musica_v1_order_';

export function loadDraft(): Partial<CreateMusicForm> | null {
  try {
    return JSON.parse(localStorage.getItem(DRAFT_KEY) || 'null');
  } catch {
    return null;
  }
}

export function saveDraft(form: CreateMusicForm) {
  try {
    localStorage.setItem(DRAFT_KEY, JSON.stringify(form));
  } catch {
    // O formulário continua funcionando quando o storage está indisponível.
  }
}

export function clearDraft() {
  try {
    localStorage.removeItem(DRAFT_KEY);
  } catch {
    // noop
  }
}

export function saveLocalOrder(order: CreateMusicOrder) {
  try {
    sessionStorage.setItem(`${ORDER_PREFIX}${order.slug}`, JSON.stringify(order));
  } catch {
    // noop
  }
}

export function loadLocalOrder(slug: string): CreateMusicOrder | null {
  try {
    return JSON.parse(sessionStorage.getItem(`${ORDER_PREFIX}${slug}`) || 'null');
  } catch {
    return null;
  }
}

export function accessTokenKey(slug: string) {
  return `${ORDER_PREFIX}${slug}_token`;
}

export function saveAccessToken(slug: string, token: string) {
  try {
    sessionStorage.setItem(accessTokenKey(slug), token);
  } catch {
    // noop
  }
}

export function loadAccessToken(slug: string) {
  try {
    return sessionStorage.getItem(accessTokenKey(slug)) || '';
  } catch {
    return '';
  }
}

export function apiFetch(action: string): string {
  return `/api/criar-musica?action=${encodeURIComponent(action)}`;
}

export function getToken(slug: string): string {
  return slug ? loadAccessToken(slug) : '';
}
